import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import { Box, Grid, Stack, Typography } from '@mui/material';

import MainCard from 'ui-component/cards/MainCard';

// ==============================|| ACCESS STATE PAGE ||============================== //

// Full-content-area message for a URL the user cannot use (no access, not
// found). Rendered inside MainLayout so the header and profile menu stay
// available; the actions are the way out. An optional aside (e.g. the
// signed-in identity) docks to the right and stacks below on narrow screens.
const AccessStatePage = ({ testId, icon, title, body, actions, hint, aside }) => {
    const theme = useTheme();

    return (
        <MainCard data-testid={testId}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={aside ? 8 : 12}>
                    <Stack spacing={2} alignItems="flex-start" sx={{ maxWidth: 560 }}>
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            {icon && (
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: '10px',
                                        flex: 'none',
                                        display: 'grid',
                                        placeItems: 'center',
                                        color: theme.palette.primary.dark,
                                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
                                    }}
                                >
                                    {icon}
                                </Box>
                            )}
                            <Typography variant="h3">{title}</Typography>
                        </Stack>
                        <Typography variant="body1">{body}</Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {actions}
                        </Stack>
                        {hint && (
                            <Typography variant="body2" color="text.secondary">
                                {hint}
                            </Typography>
                        )}
                    </Stack>
                </Grid>
                {aside && (
                    <Grid item xs={12} md={4}>
                        {aside}
                    </Grid>
                )}
            </Grid>
        </MainCard>
    );
};

AccessStatePage.propTypes = {
    testId: PropTypes.string.isRequired,
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    actions: PropTypes.node,
    hint: PropTypes.string,
    aside: PropTypes.node
};

export default AccessStatePage;
